module.exports = __webpack_public_path__ + "static/media/reportes.77374acd.ico";